import Cookies from 'js-cookie';
import { v4 as uuidv4 } from 'uuid';

export function getOrCreateUserId() {
  const cookieKey = 'anonUserId';
  let userId = Cookies.get(cookieKey);

  if (!userId) {
    userId = uuidv4();
    Cookies.set(cookieKey, userId, { expires: 365 });
  }

  return userId;
}
